<template>
  <component
    :is="transitionType"
    :tag="tag"
    v-bind="$attrs"
    @beforeEnter="beforeEnter"
    @enter="enter"
  >
    <slot/>
  </component>
</template>

<script>
import * as TweenMax from "gsap/umd/TweenMax";
// eslint-disable-next-line prefer-destructuring
export default {
  name: "AccordionTransition",
  props: {
    group: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: "div"
    }
  },
  inject: {
    eventsBus: { from: "eventsBus" }
  },
  computed: {
    transitionType() {
      return this.group ? "transition-group" : "transition";
    }
  },
  methods: {
    beforeEnter() {
      // Fixes a Chrome issue where the left side gets cut off partway down when the form is opened
      const descriptionSection = document.querySelector(
        ".p2a-campaign-content"
      );
      TweenMax.to(descriptionSection, 0, {
        height: "100%"
      });
    },
    enter(el, done) {
      const descriptionSection = document.querySelector(
        ".p2a-campaign-content"
      );
      TweenMax.to(el, 0, {
        delay: "0.05",
        onComplete() {
          TweenMax.set(descriptionSection, { height: "auto" });
          done();
        }
      });
    }
  }
};
</script>
